import { Suspense } from 'react';
import { RouterProvider } from '@tanstack/react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Sentry } from './lib/sentry';
import { queryClient } from './lib/queryClient';
import { router } from './router';
import { ThemeProvider } from './theme/ThemeProvider';
import { Toaster } from './shared/ui/Toaster';

function Loading() {
  const { t } = useTranslation();
  return <div className="app-fallback">{t('common.loading')}</div>;
}

function ErrorFallback() {
  const { t } = useTranslation();
  return (
    <div className="app-fallback">
      <p>{t('common.error')}</p>
      <button
        className="btn btn-primary"
        onClick={() => {
          window.location.reload();
        }}
      >
        {t('common.retry')}
      </button>
    </div>
  );
}

/**
 * Корневой композ: Sentry ErrorBoundary → Theme → QueryClient → Suspense → Router.
 */
export function App() {
  return (
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <Suspense fallback={<Loading />}>
            <RouterProvider router={router} />
          </Suspense>
          <Toaster />
        </QueryClientProvider>
      </ThemeProvider>
    </Sentry.ErrorBoundary>
  );
}
